import React, { Component, Fragment } from "react";
import { DatePicker, RangeDatePicker } from "jalali-react-datepicker";

import IntlMessages from "Util/IntlMessages";
import { injectIntl } from 'react-intl';
var classNames = require('classnames');
import StateButton from "Components/StateButton";

import {
    logoutUser
} from "Redux/actions";
import { connect } from "react-redux";

import API from '../../api/index';
import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import 'react-sortable-tree/style.css';
import CustomSelectInput from "Components/CustomSelectInput";
import { NotificationManager } from "Components/ReactNotifications";

import Select from "react-select";
import {
    Row,
    Button,
    FormGroup,
    Label,
    Input,
    Card,
    CardBody,
    CardTitle,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Col
} from "reactstrap";

import { Colxx } from "Components/CustomBootstrap";

class CustomerAdd extends Component {
    constructor(props) {
        super(props);

        this.state = {

        };


    }

    render() {
        return (
            this.state.isLoading ?
                <div className="loading"></div>
                :
                <Fragment>
                    <Row className="mb-4">

                        <Colxx xxs="6">
                            <Card >
                                <CardBody>
                                    <CardTitle>
                                        <div className={"simple-icon-chart headingicon"} />
                                        مشتریان قبل از هاب
                                    </CardTitle>
                                    <Row>
                                        <Colxx xxs="4">
                                            <Card className={"report-card"}>
                                                <CardBody className="text-center">
                                                    <i className="iconsminds-clock" />
                                                    <p className="card-text font-weight-semibold mb-0">
                                                        لیست مشتریان قبل از هاب
                                                    </p>
                                                    <p className="lead text-center">14</p>
                                                  
                                                </CardBody>
                                            </Card>
                                        </Colxx>
                                        <Colxx xxs="4">
                                            <Card className={"report-card"}>
                                                <CardBody className="text-center">
                                                    <i className="iconsminds-clock" />
                                                    <p className="card-text font-weight-semibold mb-0">
                                                        مشتریان قبل از هاب با اطلاعات تکمیل شده
                                                    </p>
                                                    
                                                    <p className="lead text-center">14</p>
                                                </CardBody>
                                            </Card>
                                        </Colxx>
                                        <Colxx xxs="4">
                                            <Card className={"report-card"}>
                                                <CardBody className="text-center">
                                                    <i className="iconsminds-clock" />
                                                    <p className="card-text font-weight-semibold mb-0">
                                                        مشتریان قبل از هاب با خرید موفق
                                                    </p>
                                                    <p className="lead text-center">14</p>
                                                </CardBody>
                                            </Card>
                                        </Colxx>
                                    </Row>

                                </CardBody>
                            </Card>
                        </Colxx>
                    </Row>

                </Fragment>
        );
    }
}


const mapStateToProps = ({ menu, settings }) => {
    return { logoutUser };
};
export default injectIntl(connect(
    mapStateToProps,
    { logoutUser }
)(CustomerAdd));
// export default injectIntl(ProductPriceManager);